import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMinus, faTrash } from '@fortawesome/free-solid-svg-icons'
import Spinner from '../../shared/components/Spinner'
import ShoppingBagSVG from '../../shared/icons/ShoppingBagSVG'
import TransactionHOC from '../Reusable/TransactionHOC'
import CartHOC from '../Reusable/CartHOC'
import { mixpanelLogEvent } from '../../utils/mixpanelLogEvent'
import { editCartDetail, removeCartDetail } from '../../actions'
import './AddToCart.scss'
import aa from 'search-insights'

const AdvancedAddToCartButton = props => {
  const {
    hiddenPriceBool,
    isAuthenticated,
    isAddingToCart,
    eventType,
    // validateRxAndAddToCart,
    validateRxAndAddToCartFromParent,
    id,
    itemId,
    matrixItemDetails,
    productQuantity,
    productUnits,
    unitDetails,
    setIsAddingToCart,
    queryID,
  } = props
  const dispatch = useDispatch()
  const cartDetailForItem = props.cartDetail.filter(
    item => item.itemId === Number(itemId) && item?.unit == unitDetails?.id,
  )

  const [number, setNumber] = useState(cartDetailForItem?.[0]?.quantity || 0)
  // const [isAddingToCart, setIsAddingToCart] = useState(false)

  const updateQuantity = async data => {
    const { operation, id, isOnAllocation, quantity, unit, itemId } = data

    if (quantity < 0) return

    if (quantity === 0) return dispatch(removeCartDetail(id))

    setIsAddingToCart(true)
    await dispatch(editCartDetail({ id, isOnAllocation, quantity: quantity, unit, itemId }))
    setIsAddingToCart(false)
  }

  const handleAdd = async () => {
    setIsAddingToCart(true)
    const didAdd = await addProductToCart()
    didAdd && setNumber(prevNumber => prevNumber + 1)
    setIsAddingToCart(false)
  }

  const handleDecrease = async () => {
    setNumber(prevNumber => {
      const updatedNumber = prevNumber - 1
      updateQuantity({
        operation: 'subtract',
        id: cartDetailForItem[0]?.id,
        quantity: updatedNumber,
        isOnAllocation: false,
        itemId: cartDetailForItem[0]?.itemId,
        unit: cartDetailForItem[0]?.unit || undefined,
      })
      return updatedNumber
    })
  }

  const logClickEvent = ({ eventType }) => {
    mixpanelLogEvent({
      eventType,
      userDetails: props?.auth?.user,
      itemDetails: cartDetailForItem[0],
    })
  }

  const addProductToCart = async () => {
    setIsAddingToCart(true)
    const didAddToCart = await validateRxAndAddToCartFromParent(
      matrixItemDetails?.id ? { id: matrixItemDetails?.id } : { id: id || itemId },
      productQuantity,
      productUnits.id || unitDetails.id,
    )
    if (process.env.NODE_ENV === 'production' && productQuantity == 1) {
      logClickEvent({ eventType: eventType })
      if (props?.searchTerm) {
        aa('addedToCartObjectIDsAfterSearch', {
          eventName: 'PLP Added to Cart After Search',
          index: 'itemsIndex',
          objectIDs: [String(props?.product?.id)],
          queryID: queryID,
        })
      } else {
        aa('addedToCartObjectIDs', {
          eventName: 'PLP Added to Cart',
          index: 'itemsIndex',
          objectIDs: [String(props?.product?.id)],
        })
      }
    }
    setIsAddingToCart(false)
    return didAddToCart
  }

  useEffect(() => {
    setNumber(cartDetailForItem?.[0]?.quantity || 0)
  }, [itemId, unitDetails]) //quantity always up to date

  return (
    <>
      {number < 1 ? (
        <button
          type="button"
          className="dealmed-product__add-to-cart"
          disabled={(hiddenPriceBool && isAuthenticated) || (isAddingToCart && true)}
          onClick={() => {
            handleAdd()
            logClickEvent({ eventType: `PLP_Add_To_Cart${eventType}` })
          }}
          style={hiddenPriceBool && isAuthenticated ? { backgroundColor: '#384349' } : {}}
        >
          {isAddingToCart ? (
            <Spinner />
          ) : (
            <>
              <span
                className={`enhancedAdd__products-box-buttons-addtocart-title ${
                  hiddenPriceBool && isAuthenticated ? 'unavailable' : ''
                }`}
              >
                {hiddenPriceBool && isAuthenticated ? 'Currently Unavailable' : 'Add to cart'}
              </span>
              {/* <span className="dealmed-product__add-to-cart-icon-wrapper">
                {hiddenPriceBool && isAuthenticated ? null : (
                  <ShoppingBagSVG className="dealmed-product__add-to-cart-icon" />
                )}
              </span> */}
            </>
          )}
        </button>
      ) : (
        <div
          className="dealmed-enhancedAdd__add-to-cart"
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '10px',
            // border: '1px solid lightgray',
          }}
        >
          {number <= 1 ? (
            <FontAwesomeIcon
              icon={faTrash}
              onClick={() => {
                handleDecrease()
                logClickEvent({ eventType: `PLP_Remove_From_Cart${eventType}` })
              }}
              style={{ cursor: 'pointer' }}
              className="enhancedAdd__products-box-buttons-addtocart-title"
            />
          ) : (
            <FontAwesomeIcon
              icon={faMinus}
              onClick={() => {
                handleDecrease()
                logClickEvent({ eventType: `PLP_Add_To_Cart_Decrement${eventType}` })
              }}
              style={{ cursor: 'pointer' }}
              className="enhancedAdd__products-box-buttons-addtocart-title"
            />
          )}

          <span
            className="enhancedAdd__products-box-buttons-addtocart-title"
            style={{ flex: 1, textAlign: 'center' }}
          >
            {isAddingToCart ? <Spinner /> : number === 0 ? 'Add to cart' : number}
          </span>
          <FontAwesomeIcon
            icon={faPlus}
            onClick={() => {
              handleAdd()
              logClickEvent({ eventType: `PLP_Add_To_Cart_Increment${eventType}` })
            }}
            style={{ cursor: 'pointer' }}
            className="enhancedAdd__products-box-buttons-addtocart-title"
          />
        </div>
      )}
    </>
  )
}

export default TransactionHOC(CartHOC(AdvancedAddToCartButton))
